<script>
  export let copySource;
  export let isProduction =
    window.location.href.indexOf("localhost") > -1 ||
    window.location.href.indexOf("staging") > -1;

  let buyBG =
    "https://points-ebgt.s3.amazonaws.com/marriott/promotions/2024/August/Landing_Page/new-cta-banners/PointsEvergreen_LP_BuyPointsTile%20_410x570_IMG_NoSkrim.png";
  let giftBG =
    "https://points-ebgt.s3.amazonaws.com/marriott/promotions/2024/August/Landing_Page/new-cta-banners/PointsEvergreen_LP_GiftPointsTile%20_410x570_IMG_NoSkrim.png";
  let multiply =
    "https://points-ebgt.s3.amazonaws.com/marriott/promotions/2024/August/Landing_Page/new-cta-banners/PointsEvergreen_LP_MultiplyPointsTile%20_410x570_IMG_NoSkrim.png";
  let MRBonvoyLogo = "./images/MR_Bonvoy_Logo_2022.png";
</script>

<div class="cta-container">
  <div style="background-image: url('{buyBG}');">
    <span role="img" aria-label={copySource.ctas.buy.imgAlt}> </span>
    <div class="copy-container buy">
      <h2>{copySource.ctas.buy.header}</h2>
      <p>{copySource.ctas.buy.copy}</p>
    </div>
    <a
      href={isProduction
        ? copySource.headerNav.buy.stLink
        : copySource.headerNav.buy.link}>{copySource.ctas.buy.linkCopy}</a
    >
  </div>
  <div style="background-image: url('{giftBG}');">
    <span role="img" aria-label={copySource.ctas.gift.imgAlt}> </span>
    <div class="copy-container gift">
      <h2>{copySource.ctas.gift.header}</h2>
      <p>{copySource.ctas.gift.copy}</p>
    </div>
    <a
      href={isProduction
        ? copySource.headerNav.gift.stLink
        : copySource.headerNav.gift.link}>{copySource.ctas.gift.linkCopy}</a
    >
  </div>
  <div style="background-image: url('{multiply}');">
    <span role="img" aria-label={copySource.ctas.multiply.imgAlt}> </span>
    <div class="copy-container multiply">
      <h2>{copySource.ctas.multiply.header}</h2>
      <p>{copySource.ctas.multiply.copy}</p>
    </div>
    <a
      href={isProduction
        ? copySource.headerNav.multiply.stLink
        : copySource.headerNav.multiply.link}
      >{copySource.ctas.multiply.linkCopy}</a
    >
  </div>
</div>
<div class="membership-copy">
  <a
    class="membership-link"
    href={copySource.ctas.membership.link}
    target="_blank"
  >
    <img src={MRBonvoyLogo} alt={copySource.ctas.membership.imgAlt} />
    <div class="membership-copy-con">
      <h3>
        {copySource.ctas.membership.header}
      </h3>
      <p>
        {copySource.ctas.membership.copy}
      </p>
    </div>
  </a>
</div>

<style>
  .cta-container {
    position: relative;
    display: flex;
    justify-content: center;
    gap: 15px;
    margin: 40px 10px 0 10px;
  }

  .cta-container > div {
    position: relative;
    width: 100%;
    max-width: 410px;
    height: 570px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid transparent;
    border-radius: 20px;
  }

  .cta-container > div::before {
    content: "";
    display: inline-block;
    height: 100%;
    width: 100%;
    position: relative;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8113620448179272) 0%,
      rgba(0, 0, 0, 0.0018382352941176405) 95%
    );
    border-radius: 20px;
  }

  .copy-container {
    position: absolute;
    top: 350px;
    height: 90px;
    background: transparent;
    text-align: left;
    font-family: "Swiss721 Regular";
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    color: #fff;
    padding: 10px 20px;
    transition: 0.3s ease-out top;
  }
  .copy-container:lang(zh-hans) {
    padding: 12px 20px;
    top: 370px;
  }
  .copy-container:lang(fr) {
    height: 100px;
    top: 320px;
  }
  .copy-container:lang(it) {
    top: 340px;
  }
  .copy-container:lang(en) {
    top: 375px;
  }
  .copy-container:lang(ja) {
    height: 95px;
  }
  .copy-container:lang(de) {
    top: 340px;
  }
  .copy-container.buy:lang(zh-hans) > p {
    width: 79%;
  }
  .cta-container > div > a {
    position: absolute;
    bottom: 20px;
    left: 20px;
    /* right: 20px; */
    max-width: 75%;
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 16px;
    padding: 5px 30px;
    margin-top: 20px;
    font-family: "Swiss721 Regular";
    font-size: 14px;
    color: #1c1c1c;
    text-decoration: none;
    text-transform: uppercase;
  }
  .copy-container h2 {
    font-weight: 600;
    font-size: 28px;
    margin: 0 0 7px 0;
  }

  .copy-container p {
    font-family: "Swiss721BT-light";
    font-size: 15px;
    margin: 0;
    line-height: 22px;
    width: 79%;
  }
  .copy-container.gift > p {
    white-space: pre-line;
    width: 100%;
  }
  .membership-copy {
    position: relative;
    width: 98%;
    max-width: 1270px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .membership-link {
    display: block;
    border: 1px solid #6c6c6c;
    border-radius: 20px;
    padding: 20px 10px;
  }

  .membership-link::after {
    display: inline-block;
    content: "\276F";
    font-size: 20px;
    position: absolute;
    color: #6c6c6c;
    top: 60%;
    left: 97%;
    transform: translate(-60%, -97%);
  }

  .membership-link > img {
    display: inline-block;
    width: 90px;
    vertical-align: middle;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .membership-link > div {
    display: inline-block;
    vertical-align: middle;
    max-width: 1000px;
    width: 80%;
    margin-left: 30px;
  }

  .membership-link > div > h3 {
    display: block;
    margin: 5px 0;
    font-weight: normal;
    font-family: "Swiss721 Regular";
    font-size: 18px;
  }

  .membership-link > div > p {
    display: block;
    margin: 5px 0;
    font-family: "Swiss721BT-light";
    font-size: 15px;
  }

  @media only screen and (max-width: 1200px) {
    .copy-container.gift > p {
      white-space: normal;
      /* width: 100%; */
    }
    .copy-container:lang(zh-hans) {
      top: 270px;
    }
    .copy-container:lang(es),
    .copy-container:lang(en),
    .copy-container:lang(pt) {
      top: 300px;
    }
    .copy-container:lang(de),
    .copy-container:lang(fr),
    .copy-container:lang(es),
    .copy-container:lang(ja) {
      top: 200px;
    }
    .copy-container:lang(it) {
      top: 280px;
    }
  }
  @media only screen and (max-width: 880px) {
    .copy-container:lang(en),
    .copy-container:lang(ja) {
      top: 370px;
    }
    .copy-container.gift > p {
      white-space: normal;
    }
    .copy-container {
      top: 320px;
    }
    .copy-container:lang(zh-hans),
    .copy-container:lang(pt) {
      top: 250px;
    }
    .copy-container:lang(it) {
      top: 230px;
    }
    .copy-container:lang(en) {
      top: 270px;
    }
    .copy-container:lang(pt),
    .copy-container:lang(ja) {
      top: 200px;
    }
  }
  @media only screen and (max-width: 800px) {
    .copy-container {
      top: 220px;
    }
    .copy-container:lang(de),
    .copy-container:lang(it) {
      top: 130px;
    }
    .copy-container:lang(zh-hans) {
      top: 250px;
    }
    .copy-container:lang(es) {
      top: 180px;
    }
    .copy-container > h2:lang(fr) {
      font-size: 26px;
    }
    .copy-container > p:lang(fr) {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 700px) {
    .cta-container {
      flex-direction: column;
      margin-top: 30px;
    }
    .cta-container > div {
      max-width: 700px;
      
    }
    .copy-container {
      top: 320px;
    }
    .copy-container:lang(de),
    .copy-container:lang(fr),
    .copy-container:lang(pt),
    .copy-container:lang(it),
    .copy-container:lang(es),
    .copy-container:lang(en),
    .copy-container:lang(zh-hans),
    .copy-container:lang(ja) {
      top: 350px;
    }
    .membership-link > div {
      width: 60%;
    }
  }
  @media screen and (max-width: 500px) {
    .copy-container {
      top: 320px;
    }
  }
  @media screen and (max-width: 400px) {
    .membership-link > div {
      width: 50%;
    }
    .copy-container h2 {
      font-size: 26px;
    }
    .copy-container p {
      font-size: 14px;
      width: 100%;
    }
  }

  @media all and (-ms-high-contrast: none),
    all and (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    .cta-container > div > a {
      font-family: inherit;
    }
  }
</style>
